import { Button } from "@/components/ui/button";
import heroVideo from "@/assets/hero-zen-video.mp4.asset.json";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={heroVideo.url}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-background/60" aria-hidden="true" />

      <div className="relative z-10 container mx-auto px-4 text-center max-w-4xl">
        <p className="text-sm md:text-base uppercase tracking-[0.3em] text-muted-foreground mb-6 animate-fade-in opacity-0" style={{ animationDelay: "0.2s" }}>
          A global nonprofit of human intelligence
        </p>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-heading font-bold leading-tight mb-6 text-foreground animate-fade-in opacity-0" style={{ animationDelay: "0.4s" }}>
          12,000 minds. One{" "}
          <span className="text-gradient-coral">human mycelium</span>.
        </h1>

        <p className="text-lg md:text-xl text-foreground max-w-2xl mx-auto mb-10 animate-fade-in opacity-0" style={{ animationDelay: "0.6s" }}>
          The Octopus Movement is a global nonprofit connecting nonlinear thinkers, different ways of seeing and human
          intelligence to create possibilities none of us could create alone.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in opacity-0" style={{ animationDelay: "0.8s" }}>
          <Button variant="coral" size="lg" asChild>
            <a href="#find-your-way-in">Find your way in</a>
          </Button>
          <Button variant="ghost-light" size="lg" className="text-primary border-primary/40 hover:bg-primary/10" asChild>
            <a href="#how-it-works">See how it works</a>
          </Button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
        <div className="w-6 h-10 rounded-full border-2 border-border flex justify-center pt-2">
          <div className="w-1 h-2 rounded-full bg-primary animate-pulse-glow" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
